import React from 'react';

import { useMutation } from '@tanstack/react-query';

import FormContainer from '../../FormContainer';
import UseThisAccountButton from './UseThisAccountButton';

import useBankAccountForm from '../../../../forms/loan/bankAccount';
import { useUiContext } from '../../../../context/UiContext';
import BankAccountService from '../../../../services/BankAccountService';

export default function BankAccountForm({
  bankAccount,
  setBankAccounts,
  createBankAccount,
  isPending,
  loanBankAccountId,
  useBankAccount,
  isUseBankAccountPending,
  isFetching,
  isLender,
  deleteLoanBankAccount,
  isLenderUserRole,
  refetch,
  isVendor,
}) {
  const { showDialogModal, showToast } = useUiContext();

  const deleteBankAccountWithConfirmation = async (bankAccountId) => {
    showDialogModal({
      title: 'Confiramtion',
      message: 'Are you sure you want to delete this bank account?',
      type: 'danger',
      onConfirm: () => deleteLoanBankAccount(bankAccountId),
    });
  };

  const { mutate: updateBankAccount, isPending: isUpdating } = useMutation({
    mutationFn: (formValues) =>
      BankAccountService.updateBankAccount({
        ...bankAccount,
        ...formValues,
      }),
    onSuccess: () => {
      showToast({
        text: 'Bank account updated successfully',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const isSaved = !bankAccount.notSaved;

  const form = useBankAccountForm(
    isSaved ? updateBankAccount : createBankAccount,
    bankAccount,
    isLender,
    isLenderUserRole
  );

  return (
    <div className="relative p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      {!isSaved ||
        (!isLender && !isVendor && bankAccount?.id !== loanBankAccountId && (
          <button
            onClick={() => {
              if (!isSaved) {
                setBankAccounts((prevBankAccounts) =>
                  prevBankAccounts.filter(
                    (prevBankAccount) => prevBankAccount.id !== bankAccount.id
                  )
                );
              } else {
                deleteBankAccountWithConfirmation(bankAccount.id);
              }
            }}
            type="button"
            className="absolute right-4 block rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
          >
            <span className="sr-only">Back</span>
            <svg width="32" height="32" viewBox="0 0 32 32">
              <path
                className="fill-current"
                d="M15.95 14.536l4.242-4.243a1 1 0 111.415 1.414l-4.243 4.243 4.243 4.242a1 1 0 11-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 01-1.414-1.415l4.243-4.242-4.243-4.243a1 1 0 011.414-1.414l4.243 4.243z"
              />
            </svg>
          </button>
        ))}
      <FormContainer
        groupSizeOffset={10}
        form={form}
        noBillComId={bankAccount.notSaved || isLenderUserRole}
        isSubmitting={isPending || isFetching || isUpdating}
        noSubmit={
          bankAccount?.billcom_id ||
          bankAccount?.billcom_alt_id ||
          isLenderUserRole
        }
        headerRight={
          isSaved && (
            <UseThisAccountButton
              loanBankAccountId={loanBankAccountId}
              bankAccount={bankAccount}
              // eslint-disable-next-line react-hooks/rules-of-hooks
              onClick={() => useBankAccount(bankAccount.id)}
              isPending={isUseBankAccountPending || isFetching || isPending}
              isLender={isLender}
              isVendor={isVendor}
            />
          )
        }
      />
    </div>
  );
}
